
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/masterclass/[masterclassSlug]",
      function () {
        return require("private-next-pages/masterclass/[masterclassSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/masterclass/[masterclassSlug]"])
      });
    }
  